import React from 'react';
import { Collapse } from 'antd';

const RemovedOutliers = (props) => {
    const { Panel } = Collapse;

    let removedOutliers = props.getAnalysisRes.outliers_removed;

    let outliersLower = removedOutliers.lower;
    let outliersUpper = removedOutliers.upper;

    // let outliersUpperMap;
    // if (outliersUpper.length !== 0) {
    //     outliersUpperMap = Object.values(outliersUpper).map(
    //         (item) => {
    //             return (
    //                 <tr key={item[0] + item[1] + 'cba'}>
    //                     <td>{item[0]}</td>
    //                     <td>{item[1]}</td>
    //                 </tr>
    //             );
    //         }
    //     );
    // } else {
    //     outliersUpperMap = (
    //         <tr>
    //             <td>-</td>
    //             <td>-</td>
    //         </tr>
    //     );
    // }

    // let upperTableTest = (
    //     <>
    //         <div className="removed-outliers-container">
    //             <div className="title">Upper Outliers</div>
    //             <table className="table-rm-out">
    //                 <thead>
    //                     <tr>
    //                         <td>Row</td>
    //                         <td>Value</td>
    //                     </tr>
    //                 </thead>
    //                 <tbody>{outliersUpperMap}</tbody>
    //             </table>
    //         </div>
    //     </>
    // );

    // let outliersLowerMap;
    // if (outliersLower.length == 0) {
    //     outliersLowerMap = (
    //         <tr>
    //             <td>-</td>
    //             <td>-</td>
    //         </tr>
    //     );
    // } else {
    //     outliersLowerMap = Object.values(outliersLower).map(
    //         (item) => {
    //             return (
    //                 <tr key={item[0] + item[1] + 'abc'}>
    //                     <td>{item[0]}</td>
    //                     <td>{item[1]}</td>
    //                 </tr>
    //             );
    //         }
    //     );
    // }

    // let lowerTableTest = (
    //     <>
    //         <div className="removed-outliers-container">
    //             <div className="title">Lower Outliers</div>
    //             <table className="table-rm-out">
    //                 <thead>
    //                     <tr>
    //                         <td>Row</td>
    //                         <td>Value</td>
    //                     </tr>
    //                 </thead>
    //                 <tbody>{outliersLowerMap}</tbody>
    //             </table>
    //         </div>
    //     </>
    // );

    let outliersUpperMapRow;
    let outliersUpperMapValue;
    if (outliersUpper.length !== 0) {
        outliersUpperMapRow = Object.values(outliersUpper).map((item) => {
            return <td key={item[0]+'row'}>{item[0]}</td>;
        });

        outliersUpperMapValue = Object.values(outliersUpper).map((item) => {
            return <td key={item[0]+'value'}>{item[1]}</td>;
        });
    } else {
        outliersUpperMapRow = (
            <tr>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
            </tr>
        );
        outliersUpperMapValue = (
            <tr>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
            </tr>
        );
    }

    let upperTableTest = (
        <>
            <div className="removed-outliers-container">
                <div className="title">
                    Upper Outliers ({`${removedOutliers.upper_count}`})
                </div>
                <table className="table-rm-out">
                    <tbody>
                        <tr>
                            <td>Row</td>
                            {outliersUpperMapRow}
                        </tr>
                        <tr>
                            <td>Value</td>
                            {outliersUpperMapValue}
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    );

    let outliersLowerMapRow;
    let outliersLowerMapValue;
    if (outliersLower.length == 0) {
        outliersLowerMapRow = (
            <>
                <tr>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
            </>
        );
        outliersLowerMapValue = (
            <tr>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
            </tr>
        );
    } else {
        outliersLowerMapRow = Object.values(outliersLower).map((item) => {
            return <td key={item[0]+'row'}>{item[0]}</td>;
        });

        outliersLowerMapValue = Object.values(outliersLower).map((item) => {
            return <td key={item[0]+'value'}>{item[1]}</td>;
        });
    }

    let lowerTableTest = (
        <>
            <div className="removed-outliers-container">
                <div className="title">
                    Lower Outliers ({`${removedOutliers.lower_count}`})
                </div>
                <table className="table-rm-out">
                    <tbody>
                        <tr>
                            <td>Row</td>
                            {outliersLowerMapRow}
                        </tr>
                        <tr>
                            <td>Value</td>
                            {outliersLowerMapValue}
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    );

    return (
        <>
            <Collapse bordered={false} defaultActiveKey={[1]}>
                <Panel
                    key={1}
                    header={`Removed Outliers`}
                    // showArrow={false}
                    id="id-remove-outliers"
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between'
                        }}
                    >
                        <div
                            style={{
                                width: '100%',
                                marginBottom: 30
                            }}
                        >
                            {lowerTableTest}
                        </div>

                        <div
                            style={{
                                width: '100%'
                            }}
                        >
                            {upperTableTest}
                        </div>
                    </div>
                </Panel>
            </Collapse>
        </>
    );
};

export default React.memo(RemovedOutliers);
// export default RemovedOutliers;
